import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import { ReactComponent as CalanderSvg } from '../../image/Calander.svg';
import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import { ReactComponent as DoubleLeftArrowSvg } from '../../image/DoubleLeftArrow.svg';
import { ReactComponent as PlusSvg } from '../../image/Plus.svg';

const NewCalenderInput = forwardRef((props, ref) => {
  const { value, setValue, onUserChange, className, selectClickFn, placeholder, clickFn, disabled, width, calenderLeft } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [today, setToday] = useState(moment());
  const [isClicked, setIsClicked] = useState(false);
  const [dateList, setDateList] = useState([]);
  // const [value, setValue] = useState('');

  const CalenderRef = useRef();

  const firstWeek = today.clone().startOf('month').week();
  const lastWeek = today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setValue(val)
    },
    getValue: () => {
      return value;
    },
    closeCalender: () => {
      setIsClicked(false);
    }
  }));

  useEffect(() => {
    let newDateList = [];

    for (let week = firstWeek; week <= lastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().startOf('year').week(week).startOf('week').add(i, 'day');
        
        newDateList.push(days);
      } 
    }
    setDateList(newDateList);

    if (isClicked) {
      CalenderRef.current.style.height = `${65 + 44 * (newDateList.length / 7)}px`;
      CalenderRef.current.style.border = `1px solid ${theme.primary}`;
      CalenderRef.current.style.zIndex = `30`;
      CalenderRef.current.style.opacity = `1`;
    }
    else {
      CalenderRef.current.style.height = `0px`;
      CalenderRef.current.style.border = `0px solid ${theme.primary}`;
      CalenderRef.current.style.zIndex = `-3`;
      CalenderRef.current.style.opacity = `0`;
    }
  }, [isClicked, today, firstWeek, lastWeek]) 

  function inputClick() {
    if (disabled) return;
    
    setIsClicked(!isClicked);
    setToday(moment());
    clickFn(className);
    selectClickFn();
  }

  function dateClick(index) {
    const formatted = dateList[index].format(t('memberDetail.membershipEditModal.dateFormat'));
    setValue(formatted);
    if (onUserChange) onUserChange(formatted);
    setIsClicked(false);
  }

  return (
    <TopLevelWrapper>
      {/* <Input img={CalenderImagePath} onClick={inputClick} disabled={disabled} width={width}>
        <Text black={value !== '' ? true : false}>
          {
            value !== '' ? value : placeholder
          }
        </Text>
      </Input> */}
      <Input onClick={inputClick} disabled={disabled} width={width}>
        <CalanderIcon disabled={disabled}/>
        <Text color={theme.text}>
          {
            value !== '' ? moment(value).format(t('memberDetail.membershipEditModal.dateFormat')) : placeholder
          }
        </Text>
      </Input>
      <CalenderView ref={CalenderRef} calenderLeft={calenderLeft}>
        <TitleWrapper>
          <LayerWrapper>
            <DoubleLeftArrowIcon onClick={() => setToday(today.clone().subtract(1, 'year'))} style={{ margin: `0 -7px 0 0` }} />
            <LeftArrowIcon onClick={() => setToday(today.clone().subtract(1, 'month'))} />
            <Title>{today.format(t('calendarInput.calendarFormat'))}</Title>
            <RightArrowIcon onClick={() => setToday(today.clone().add(1, 'month'))} />
            <DoubleRightArrowIcon onClick={() => setToday(today.clone().add(1, 'year'))} style={{ margin: `0 0 0 -7px` }} />
          </LayerWrapper>
          <ExitButtonIcon onClick={() => setIsClicked(false)} />
        </TitleWrapper>
        <DateColumnWrapper>
          <DateColumn style={{ width: `25px`, marginRight: `16px` }}>SUN</DateColumn>
          <DateColumn style={{ width: `30px`, marginRight: `15px` }}>MON</DateColumn>
          <DateColumn style={{ width: `23px`, marginRight: `16px` }}>TUE</DateColumn>
          <DateColumn style={{ width: `28px`, marginRight: `16px` }}>WED</DateColumn>
          <DateColumn style={{ width: `25px`, marginRight: `21px` }}>THU</DateColumn>
          <DateColumn style={{ width: `18px`, marginRight: `21px` }}>FRI</DateColumn>
          <DateColumn style={{ width: `24px`/*, marginRight: `16px`*/ }}>SAT</DateColumn>
        </DateColumnWrapper>
        <DateWrapper>
          {
            dateList.map((data, index) => (
              data.format('MM') === today.format('MM') ?
              // <Date key={index} isClicked={today.format('YYYY.MM.DD') === data.format('YYYY.MM.DD')} onClick={() => dateClick(index)}>
              <Date key={index} isClicked={value === '' ? today.format(t('memberDetail.membershipEditModal.dateFormat')) === data.format(t('memberDetail.membershipEditModal.dateFormat')) : value === data.format(t('memberDetail.membershipEditModal.dateFormat'))} onClick={() => dateClick(index)}>
                {data.format('D')}
              </Date>
              :
              <WithoutHoverDate key={index}>
                {data.format('D')}
              </WithoutHoverDate>
            ))
          }
        </DateWrapper>
      </CalenderView>
    </TopLevelWrapper>
  )
})

export default NewCalenderInput;

const TopLevelWrapper = styled.div`
  width: ${props => props.width || '100%'};
`;

const Input = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  
  width: 100%;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  // background: url(${props => props.img}) no-repeat 10px center;

  gap: 10px;

  transition: all 0.2s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.2s ease-in-out;
`;

const CalenderView = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 25px 17px;

  gap: 20px;

  border: 0px solid ${props => props.theme.primary};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  z-index: -30;
  opacity: 0;

  margin-top: 10px;
  left: ${props => props.calenderLeft ?? '20px'};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const CalanderIcon = styled(CalanderSvg)`
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  opacity: ${props => props.disabled ? 0.5 : 1};

  & path { fill: ${props => props.theme.line}; }

  transition: all 0.2s ease-in-out;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  width: 100%;

  padding: 0 10px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 15px;
`;

const ExitButtonIcon = styled(PlusSvg)`
  width: 16px;
  height: 16px;

  transform: rotate(45deg);
  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LeftArrowIcon = styled(LeftArrowSvg)`
  width: 8px;
  height: 13px;

  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const RightArrowIcon = styled(LeftArrowSvg)`
  width: 8px;
  height: 13px;

  transform: rotate(180deg);
  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DoubleLeftArrowIcon = styled(DoubleLeftArrowSvg)`
  width: 16px;
  height: 24px;

  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DoubleRightArrowIcon = styled(DoubleLeftArrowSvg)`
  width: 16px;
  height: 24px;

  transform: rotate(180deg);
  color: ${props => props.theme.text};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const DateColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
`;

const DateColumn = styled.p`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: NotoSansKR-Bold;
  font-size: 12px;

  color: ${props => props.theme.primary};

  margin: 0 1px 0 1px;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 304px;
`;

const Date = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 40px;

  margin: 0 1.7px 2px 1.7px;

  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.isClicked ? props.theme.subBackground : props.theme.text};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primaryHover};
      color: ${props => props.theme.subBackground};

      font-fmaily: Poppins-Bold;
    }
  }
`;

const WithoutHoverDate = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 40px;

  margin: 0 1.7px 2px 1.7px;

  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;